import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compound-search',
  templateUrl: './compound-search.component.html',
  styleUrls: ['./compound-search.component.css']
})
export class CompoundSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
